import React from "react";
import styled from "styled-components";
import config from "../../config";
import PlayButtonLG from "./PlayButtonLG";
import DEFAULT_PPT_IMG from "../../assets/defaultImg/default_ppt_image.svg";
import {IPTImage} from "../../interfaces/IPTInformation";

const StyledPresentationViewer = styled.div`
    flex:1;
    position:relative;
    background: #ECECEC;
    background: #555555;
    border: 1px solid #555555;
`;

const SlideFrame = styled.div`
    width:100%;
    /* height:100%; */
    /* flex:1; */
    &:focus {
        outline:none;
    }
    display:flex;
    flex-direction:row;
    flex-wrap:nowrap;
    justify-content:flex-start;
    align-items:center;
    height:100%;
    .frame {
        position:relative;
        width:100%;
        height:100%;
        overflow:hidden;
        .container {
            height:100%;
            width:auto;
            white-space:nowrap;
            transition:transform ease .5s;
            transform: ${(props) => `translate(${((props as any)['data-slide'] - 1) * -100}%, 0)`};
            .slide {
                width:100%;
                height:100%;
                position:relative;
                /* height:40rem; */
                display:inline-flex;
                justify-content:center;
                align-items:center;
                background-color: #555555};
                &.recording {
                    img {
                        border:3px solid #E03E31;
                    }
                }
                img{
                    width:100%;
                    height:100%;
                    position:absolute;
                    object-fit:contain;
                }
            }
        }
    }
`;

const StyledPresentationCover = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    z-index: 1;
    
    img {
        border-radius: 5;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
`;

interface IPresentationViewer {
    videoDOM?: HTMLVideoElement,
    images: IPTImage[],
    tempSlideIndex: number,
    currentSlideIndex: number
}

const PresentationViewer: React.FC<IPresentationViewer> = (({
                                                                videoDOM,
                                                                images,
                                                                tempSlideIndex,
                                                                currentSlideIndex
                                                            }) => {

    return (
        <StyledPresentationViewer>
            <SlideFrame data-slide={tempSlideIndex ? tempSlideIndex : currentSlideIndex}>
                <div className='frame'>
                    {videoDOM?.paused && (
                        <StyledPresentationCover>
                            <div onClick={() => videoDOM.play()}>
                                <PlayButtonLG/>
                            </div>
                        </StyledPresentationCover>
                    )}
                    <div className='container'>
                        {
                            images.map((image, slideIdx) => (
                                <div
                                    key={`slide-${slideIdx}`}
                                    data-slide={`${image.fileUrl}`}
                                    // data-slide={`${config.hostRes}api/file/${image.id}`}
                                    className={`slide slide-1`}>
                                    <img src={`${image.fileUrl}`} alt={`슬라이드 #${slideIdx + 1}`} onError={(e: any) => {
                                    {/*<img src={`${config.hostRes}api/file/${image.id}`} alt={`슬라이드 #${slideIdx + 1}`} onError={(e: any) => {*/}
                                        e.currentTarget.src = DEFAULT_PPT_IMG;
                                    }}/>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </SlideFrame>
        </StyledPresentationViewer>
    )
});

export default PresentationViewer;
